export const SET_ROUTE = 'set_route';
export const SUCCESS_LOGIN = 'success_login';
export const SET_LOGOUT = 'set_logout';
export const UPDATE_TOKEN = 'update_token';
export const REMEMBER_ME = 'remember_me';
export const TOGGLE_SIDEBAR = 'toggle_sidebar';
export const UPDATE_PERMISSION = 'update-permission';
